{
  "instances": {
    "quartz": {
      "actions": "Actions",
      "active_triggers": "Active Triggers",
      "associated_triggers": "Associated Triggers",
      "associated_with_calendar": "Associated with calendar",
      "basic_information": "Basic Information",
      "calendar": "Calendar",
      "class": "Class",
      "configuration": "Configuration",
      "cron_expression": "Cron Expression",
      "custom_trigger": "Custom Trigger",
      "days_of_week": "Days of Week",
      "description": "Description",
      "details": "Details",
      "disabled": "Disabled",
      "durable": "Durable",
      "enabled": "Enabled",
      "end_time": "End Time",
      "final_fire_time": "Final Fire Time",
      "friday": "Friday",
      "group": "Group",
      "infinite": "Infinite",
      "interval": "Interval",
      "job_data": "Job Data",
      "job_name": "Job Name",
      "jobs": "Jobs",
      "key": "Key",
      "label": "Quartz",
      "last_fire": "Last Fire",
      "last_fire_time": "Last Fire Time",
      "monday": "Monday",
      "name": "Name",
      "next_fire": "Next Fire",
      "next_fire_time": "Next Fire Time",
      "no": "No",
      "no_data": "No Quartz information available",
      "paused_triggers": "Paused Triggers",
      "preserve_hour_of_day": "Preserve Hour of Day",
      "priority": "Priority",
      "recovery": "Recovery",
      "repeat_count": "Repeat Count",
      "request_recovery": "Request Recovery",
      "saturday": "Saturday",
      "schedule_configuration": "Schedule Configuration",
      "skip_day_if_hour_does_not_exist": "Skip Day If Hour Does Not Exist",
      "start_time": "Start Time",
      "state": "State",
      "sunday": "Sunday",
      "system_default": "System Default",
      "thursday": "Thursday",
      "time_window": "Time Window",
      "time_zone": "Time Zone",
      "times_triggered": "Times Triggered",
      "timing_information": "Timing Information",
      "total": "total",
      "trigger_data": "Trigger Data",
      "trigger_failed": "Trigger Failed",
      "trigger_failed_message": "Failed to trigger job: {error}",
      "trigger_failed_notification": "Failed to trigger job \"{jobName}\": {error}",
      "trigger_fire_times": "Trigger Fire Times",
      "trigger_job_now": "Trigger Job Now",
      "trigger_success_message": "Job \"{jobName}\" triggered successfully",
      "trigger_success_title": "Job Triggered",
      "triggers": "Triggers",
      "tuesday": "Tuesday",
      "type": "Type",
      "value": "Value",
      "wednesday": "Wednesday",
      "yes": "Yes"
    }
  }
}
